import { OVERFLOW_THRESHOLD_PX } from './column-width-functions';

export const WHEEL_EDGE_RELEASE_PX = 1;
export const EDGE_SHADOW_ON_PX = 3;
export const EDGE_SHADOW_OFF_PX = 1;
export const MIN_THUMB_WIDTH_PX = 8;

export function clampToUnitInterval(value: number): number {
	return Math.min(1, Math.max(0, value));
}

export function getHorizontalScrollProgress(scrollEl: HTMLElement): number {
	const maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
	if (maxScroll <= OVERFLOW_THRESHOLD_PX) {
		return 0;
	}

	const rtl = getComputedStyle(scrollEl).direction === 'rtl';
	const { scrollLeft } = scrollEl;

	if (!rtl) {
		return clampToUnitInterval(scrollLeft / maxScroll);
	}
	if (scrollLeft < 0) {
		return clampToUnitInterval(-scrollLeft / maxScroll);
	}
	return clampToUnitInterval(1 - scrollLeft / maxScroll);
}

export function hasRealHorizontalOverflow(scrollEl: HTMLElement): boolean {
	return scrollEl.scrollWidth - scrollEl.clientWidth > OVERFLOW_THRESHOLD_PX;
}

export function computeScrollThumbStyle(
	scrollEl: HTMLElement,
	trackWidth: number
): { width: string; transform: string; visible: boolean } {
	const maxScrollPx = scrollEl.scrollWidth - scrollEl.clientWidth;

	if (maxScrollPx <= OVERFLOW_THRESHOLD_PX || trackWidth <= 0) {
		return { width: '100%', transform: 'translateX(0)', visible: false };
	}

	const { clientWidth, scrollWidth } = scrollEl;
	const thumbWidth = Math.max((clientWidth / scrollWidth) * trackWidth, MIN_THUMB_WIDTH_PX);
	const maxThumbOffset = Math.max(trackWidth - thumbWidth, 0);
	const ratio = getHorizontalScrollProgress(scrollEl);
	const offset = maxThumbOffset > 0 ? ratio * maxThumbOffset : 0;

	return {
		width: `${thumbWidth}px`,
		transform: `translateX(${offset}px)`,
		visible: true,
	};
}
